import { render, staticRenderFns } from "./IndividualCourseYearRevenuePanel.vue?vue&type=template&id=72735801&scoped=true"
import script from "./IndividualCourseYearRevenuePanel.vue?vue&type=script&lang=js"
export * from "./IndividualCourseYearRevenuePanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72735801",
  null
  
)

export default component.exports